/**
 * The adapter provider parties
 */
export var AdapterProvider;
(function (AdapterProvider) {
    AdapterProvider["Centro"] = "Centro";
    AdapterProvider["Hvc"] = "Hvc";
    AdapterProvider["Consumer"] = "Consumer";
})(AdapterProvider || (AdapterProvider = {}));
/**
 * The adapter types
 */
export var AdapterType;
(function (AdapterType) {
    AdapterType["Request"] = "Request";
    AdapterType["History"] = "History";
    AdapterType["DataSources"] = "DataSources";
    AdapterType["SetTitleImpl"] = "SetTitleImpl";
})(AdapterType || (AdapterType = {}));
